<template>
  <vue-resizable
    v-if="title != 'RecycleBin'"
    style="z-index: 1"
    dragSelector=".desktopIcon"
    :active="[]"
    :disableAttributes="['w', 'h']"
    :ref="'icon_' + title"
    @drag:start="savePos()"
    @drag:move="preventClick()"
    @drag:end="movedToRecycle($event)"
  >
    <div class="desktopIcon selected" @click="click()">
      <div
        class="desktopIconImg"
        :style="{
          'background-image':
            'url(' + require('@/assets/' + title + '.png') + ')',
        }"
      ></div>
      <div class="desktopIconText">{{ title }}.html</div>
      <!-- {{ clicked }}
    {{ selected }} -->
    </div>
  </vue-resizable>
  <div v-else class="desktopIcon bin">
    <div
      class="desktopIconImg"
      :style="{
        'background-image':
          'url(' + require('@/assets/' + title + '.png') + ')',
      }"
    ></div>
    <div class="desktopIconText">{{ title }}</div>
  </div>
</template>

<script>
import VueResizable from "vue-resizable";
export default {
  props: {
    title: String,
  },
  data: function () {
    return {
      clicked: 0,
      selected: false,
      isDragged: false,
      step: 0,
      lastPosTop: 0,
      lastPosLeft: 0,
    };
  },
  methods: {
    movedToRecycle() {
      const offsetBottom =
        window.innerHeight - this.$refs["icon_" + this.title].$el.offsetTop;
      const offsetRight =
        window.innerWidth - this.$refs["icon_" + this.title].$el.offsetLeft;
      if (offsetRight < 215 && offsetBottom < 300) {
        this.$emit("easterEgg", { step: this.step, program: this.title });
        this.step++;
        if (this.step >= 3) this.step = 0;
        this.$refs["icon_" + this.title].l = this.lastPosLeft;
        this.$refs["icon_" + this.title].t = this.lastPosTop;
      }
    },
    click() {
      if (!this.isDragged) {
        this.clicked++;
        this.selected = false;
        this.$emit("clicked", "");
      }
      this.isDragged = false;
    },
    preventClick() {
      if (!this.isDragged) this.isDragged = true;
    },
    savePos() {
      this.lastPosLeft = this.$refs["icon_" + this.title].l;
      this.lastPosTop = this.$refs["icon_" + this.title].t;
    },
  },
  name: "DesktopIcon",
  components: {
    VueResizable,
  },
};
</script>

<style>
.desktopIcon {
  padding: 5px;
  cursor: pointer;
  max-width: 100px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  margin-right: 5px;
  z-index: 1;
  transition: background-color 0.2s cubic-bezier(0.23, 1, 0.32, 1);
}
/* .desktopIconsMobile .desktopIcon {
  padding: none;
} */
.bin {
  cursor: auto;
}
.desktopIcon .desktopIconImg {
  width: 80px;
  height: 80px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.desktopIcon .desktopIconText {
  margin-top: 5px;
  text-align: center;
  color: var(--font-color);
  word-break: break-word;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}
.selected:hover {
  background-color: var(--primary-dark);
}
</style>
